import React, { useState, useMemo, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Badge, Box, Button, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useWSContext } from '../../context/WebSocketContext';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

// --- Estilos que não mudam ---
const innerBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  p: 0.5,
  textDecoration: 'none',
  borderRadius: 7,
};

const contentBoxStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  m: 1,
};

const buttonStyles = {
  p: 0.2,
};

export default function BoxClienteFila({ cliente }) {
  const theme = useTheme();
  const { handleSendMessageWS } = useWSContext();
  const [disableButton, setDisableButton] = useState(false);
  const [titleButtonAtendimento, setTitleButtonAtendimento] =
    useState('Iniciar atendimento');

  // Estilos que dependem do 'theme' são memoizados para melhor performance
  const rootBoxStyles = useMemo(
    () => ({
      display: 'flex',
      mb: 0.5,
      borderRadius: 1,
      background: theme.palette.gradients.dark,
      border: `1px solid ${theme.palette.divider}`,
    }),
    [theme]
  );

  // Otimizando a função de callback para evitar recriações desnecessárias
  const handleIniciaAtendimento = useCallback(() => {
    console.log('Solicitando próximo cliente da fila...');
    handleSendMessageWS({ serviceType: 'getUser' });
  }, [handleSendMessageWS]);

  if (!cliente) {
    return null;
  }

  return (
    <Box sx={rootBoxStyles}>
      <Box sx={innerBoxStyles}>
        <Box sx={contentBoxStyles}>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            variant="dot"
          >
            <Avatar
              alt={cliente?.name}
              src={cliente?.avatar}
              sx={{ width: 30, height: 30 }}
            />
          </StyledBadge>
          <Typography variant="subtitle2" sx={{ color: 'text.primary', ml: 1 }}>
            {cliente?.name}
          </Typography>
        </Box>
        <Button
          variant="contained"
          fullWidth
          disabled={disableButton}
          onClick={handleIniciaAtendimento}
          sx={buttonStyles}
        >
          {titleButtonAtendimento}
        </Button>
      </Box>
    </Box>
  );
}
